import { render, staticRenderFns } from "./DefaultFilterPage.vue?vue&type=template&id=370cea49&"
import script from "./DefaultFilterPage.vue?vue&type=script&lang=js&"
export * from "./DefaultFilterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports